import React from 'react';
import classNames from 'classnames';
import { Chip, ChipColor } from '../../../Chip';
import { CopyButton } from '../../../CopyButton';

interface PropTypes {
  label: string;
  value: string;
  className?: string;
  copy?: boolean;
}

export function CardEntry(props: PropTypes) {
  if (props.value == null || props.value == '') return null;

  return (
    <div className={classNames('d-flex align-items-center', props.className)}>
      <span className='me-auto fs-5'>{props.label}</span>
      <Chip className='fw-semibold' color={ChipColor.Gray}>
        {props.value}
      </Chip>
      {props.copy && (
        <CopyButton
          textToBeCopied={props.value}
          tooltipTextOnClick={'Requisition ID copied!'}
          hideText={true}
          size={'lg'}
          buttonClass={'px-2h py-0'}
        />
      )}
    </div>
  );
}
